import React from "react";
import styles from "./ProductAttributesTable.module.css";

interface AttributeValue {
  name: string;
  colorHex?: string | null;
}

interface Attribute {
  name: string;
  values?: AttributeValue[]; // Allow `values` to be optional
}

interface ProductAttributesTableProps {
  attributes?: Attribute[]; // Allow `attributes` to be optional
  sku?: string; // Add SKU as an optional prop
}

const ProductAttributesTable: React.FC<ProductAttributesTableProps> = ({
  attributes = [], // Default to an empty array if attributes is undefined
  sku,
}) => {
  return (
    <div className={styles.tableContainer}>
      {attributes.length > 0 || sku ? (
        <table className={styles.attributesTable}>
          <thead>
            <tr>
              <th>Atributo</th>
              <th>Detalle</th>
            </tr>
          </thead>
          <tbody>
            {sku && (
              <tr>
                <td>SKU</td>
                <td>{sku}</td>
              </tr>
            )}
            {attributes.map((attribute) => (
              <tr key={attribute.name}>
                <td>{attribute.name}</td>
                <td>
                  {Array.isArray(attribute.values) &&
                  attribute.values.length ? (
                    attribute.values.map((value, index) => (
                      <span key={index} className={styles.valueItem}>
                        {value.colorHex ? (
                          <span
                            className={styles.colorSwatch}
                            style={{ backgroundColor: value.colorHex }}
                          />
                        ) : null}
                        {value.name}
                      </span>
                    ))
                  ) : (
                    <span className={styles.noValues}>No values available</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className={styles.noAttributes}>No attributes available</p>
      )}
    </div>
  );
};

export default ProductAttributesTable;
